import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { applySeo } from './seo';

/**
 * 화면 단위로 문서 메타를 지정합니다.
 *
 *   useSeo({ page: 'community', path: '/community' });
 *
 * page 를 생략하면 locale 의 meta.title / meta.description(사이트 기본값)을 씁니다.
 * 문구는 각 언어 locale 의 meta.pages.<page> 에서 가져오므로 언어 전환에도 따라갑니다.
 *
 * @param {object}  options
 * @param {string}  [options.page]    locale 의 meta.pages 하위 키
 * @param {string}  [options.path]    canonical 경로 (기본 '/')
 * @param {boolean} [options.noindex] 로그인 이후 화면처럼 색인에서 빼야 하는 경우 true
 * @param {object}  [options.jsonLd]  라우트 전용 구조화 데이터
 */
const useSeo = ({ page, path = '/', noindex = false, jsonLd } = {}) => {
  const { t, i18n } = useTranslation();

  // jsonLd 는 객체 리터럴로 넘어오는 경우가 많아 매 렌더 참조가 바뀝니다.
  // 값이 같으면 다시 그리지 않도록 직렬화한 문자열을 의존성으로 씁니다.
  const jsonLdKey = jsonLd ? JSON.stringify(jsonLd) : '';

  useEffect(() => {
    const title = page ? t(`meta.pages.${page}.title`) : t('meta.title');
    const description = page
      ? t(`meta.pages.${page}.description`)
      : t('meta.description');

    applySeo({
      title,
      description,
      path,
      noindex,
      jsonLd: jsonLdKey ? JSON.parse(jsonLdKey) : undefined,
    });
    // i18n.resolvedLanguage 를 의존성에 두어 언어 전환 시 다시 계산합니다.
  }, [t, i18n.resolvedLanguage, page, path, noindex, jsonLdKey]);
};

export default useSeo;
